import React from "react";

import Button from "@mui/material/Button";

import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

type FooterActionsProps = {
  onCancel?: () => void;
  onSave?: () => void;
  onSaveAndBack?: () => void;
  cancelLabel?: string;
  saveLabel?: string;
  showSaveAndBack?: boolean;
};

const FooterActions = ({
  onCancel,
  onSave,
  onSaveAndBack,
  cancelLabel,
  saveLabel,
  showSaveAndBack,
}: FooterActionsProps) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate(-1);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave();
    }
  };

  const handleSaveBack = () => {
    if (onSaveAndBack) {
      onSaveAndBack();
      navigate(-1);
    }

    if (showSaveAndBack) {
      navigate(-1);
    }
  };

  return (
    <Grid container direction="row" style={{ marginTop: 50 }}>
      <Grid item xs={12} sm={6} md={6}>
        <Button onClick={handleCancel}>{cancelLabel}</Button>
      </Grid>

      <Grid
        container
        direction="row"
        xs={12}
        sm={6}
        md={6}
        justifyContent="flex-end"
      >
        {(onSaveAndBack || showSaveAndBack) && (
          <Grid item xs={12} sm={6} md={4}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleSaveBack}
              type="submit"
            >
              Salvar e voltar
            </Button>
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSave}
            type="submit"
          >
            {saveLabel}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

FooterActions.defaultProps = {
  onCancel: null,
  onSaveAndBack: null,
  cancelLabel: "Cancelar",
  saveLabel: "Salvar",
  onSave: null,
};

export default React.memo(FooterActions);
